import React, { useRef } from 'react';
import { Tooltip } from "../../tooltip/Tooltip.js";
import styles from "./ErrorTooltip.module.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ErrorTooltip({
  icon: Icon,
  content,
  open,
  onOpenChange,
  offsetY
}) {
  const iconRef = useRef(null);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      className: styles.iconButton,
      onClick: () => onOpenChange(!open),
      children: /*#__PURE__*/_jsx(Icon, {
        ref: iconRef,
        size: "SMALL"
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      iconRef: iconRef,
      content: content,
      onCloseClick: () => onOpenChange(false),
      onClickOutside: () => onOpenChange(false),
      type: "error",
      placement: "bottom",
      open: open,
      offsetY: offsetY,
      noStatusIcon: true
    })]
  });
}